import { CreateDiscussion } from "../../CreateDiscussion/CreateDiscussion";
import React from "react";
import ReactDOM from "react-dom/client";
import StorageKeys from "../../../Utility/StorageKey.js";
import { updatePostPrivacyStatus } from "./PostPrivacyAxios";

var post_id;
var likes_array;
//g_starter();
//setInterval(g_output04, 10000);
//setInterval(g_output05, 20000);

class TTimeKeeperRenderer {
  fillPost(Objects) {
    console.log(Objects);
    var size = Objects ? Object.keys(Objects).length : 0;

    // When there are no posts, show an informative placeholder
    if (size === 0) {
      const placeholder = document.createElement("div");
      placeholder.className = "no-posts-placeholder";
      placeholder.style.cssText =
        "margin:16px auto;padding:16px 20px;border-radius:12px;max-width:720px;background:#1f2937;color:#f9fafb;border:1px solid #374151;text-align:center;font-size:14px;";
      placeholder.textContent = "There are no posts yet :)";

      const target = document.getElementById("main");
      if (!document.querySelector(".no-posts-placeholder")) {
        target.appendChild(placeholder);
      }
      return;
    }

    // Render single post object
    loadpost(
      Objects.id,
      Objects.body,
      Objects.time,
      Objects.likes,
      Objects.title,
      Objects.user_id,
      Objects.mode,
      Objects.imageUrl,
      Objects.PrivacyStatus || "public"
    );
  }
}

const TTimeKeeperRendererInstance = new TTimeKeeperRenderer();
export default TTimeKeeperRendererInstance;
export { TTimeKeeperRenderer };

// Backward-compatible function export so existing callers continue to work
export function f_ill_post(Objects) {
  return TTimeKeeperRendererInstance.fillPost(Objects);
}

function loadpost(
  id,
  text,
  time,
  likes,
  title,
  anonymous,
  mode,
  imageUrl,
  privacyStatus = "public"
) {
  //console.log(text);
  //console.log(time);
  console.log(anonymous);
  console.log("Mode:", mode); // Log the mode for debugging
  var mains = document.createElement("DIV");
  var tag_id = "C_container_tag" + id;
  mains.id = "app_2";
  mains.style.animation = "fadein 0.5s ease-in";
  document
    .getElementById("main")
    .insertBefore(mains, document.getElementById("app_1").nextSibling);
  localStorage.setItem("id", id);
  console.log(localStorage.getItem("id") + "ini id dia");
  post_id = id;

  var Paragraph_className = "Message p-4 pt-2 text-sm font-medium";

  // Function to get mode-specific styling and icon
  const getModeConfig = (mode) => {
    switch (mode) {
      case "opinion":
        return {
          color: "border-orange-500",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
              />
            </svg>
          ),
          label: "Opinion",
        };
      case "prayer":
        return {
          color: "border-blue-500",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
              />
            </svg>
          ),
          label: "Prayer",
        };
      case "event":
        return {
          color: "border-green-500",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          ),
          label: "Event",
        };
      case "discussion":
        return {
          color: "border-purple-500",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"
              />
            </svg>
          ),
          label: "Discussion",
        };
      case "question":
        return {
          color: "border-red-500",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          ),
          label: "Question",
        };
      default:
        return {
          color: "border-gray-500",
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
          ),
          label: "Post",
        };
    }
  };

  var Container = (props) => {
    const [state, setState] = React.useState({
      profile_image: "",
      discussions: 0,
      isVisible: false,
      privacyStatus: props.privacyStatus || "public", // Default to public
      showPrivacyMenu: false,
    });

    React.useEffect(() => {
      // Example: Fetch profile image or discussions count

      if (anonymous != "anonymous") {
        setState({
          profile_image: StorageKeys.SupabaseUrlProfile + anonymous,
        });
      }
    }, []);

    // Close privacy menu when clicking outside
    React.useEffect(() => {
      if (state.showPrivacyMenu) {
        const handleClickOutside = (event) => {
          if (!event.target.closest(".privacy-menu-container")) {
            setState((prev) => ({ ...prev, showPrivacyMenu: false }));
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }
    }, [state.showPrivacyMenu]);

    const handleClick = () => {
      const { id, anonymous, title, text, time, mode, imageUrl } = props;

      // Check if this is an event post
      if (mode === "event") {
        // Store event data in sessionStorage
        sessionStorage.setItem(
          "eventData",
          JSON.stringify({
            id,
            anonymous,
            title,
            text,
            time,
            mode,
            imageUrl,
          })
        );

        // Redirect to EventComponent
        const baseUrl = window.location.origin;
        const urlWithParams = `${baseUrl}/EventPage/${id}`;
        window.location.href = urlWithParams;
        return;
      }

      // Check if this is a question post
      if (mode === "question") {
        // Store question data in sessionStorage
        sessionStorage.setItem(
          StorageKeys.discussionData,
          JSON.stringify({
            id,
            anonymous,
            title,
            text,
            time,
            mode,
          })
        );

        // Redirect to QuestionPage
        const baseUrl = window.location.origin;
        const urlWithParams = `${baseUrl}/QuestionPage/${id}`;
        window.location.href = urlWithParams;
        return;
      }

      // For non-event posts, use the original discussion flow
      sessionStorage.setItem(
        StorageKeys.discussionData,
        JSON.stringify({
          id,
          anonymous,
          title,
          text,
          time,
        })
      );

      //get the link in engine javasciprt_initializer
      const baseUrl = window.location.origin;

      // Create a URL with query parameters
      const urlWithParams = `${baseUrl}/DiscussionPage/${id}`;

      window.location.href = urlWithParams;
    };

    const toggleDiscussion = () => {
      setState((prevState) => ({
        isVisible: !prevState.isVisible,
      }));
    };

    const modeConfig = getModeConfig(props.mode);

    return (
      <div className={`w-full lg:flex lg:max-w-full `}>
        <div className="flex w-full flex-col justify-between border-t border-[#FFFFFF19] p-4 pb-2 leading-normal lg:border-l-0 lg:border-t lg:border-[#FFFFFF19]">
          {/* Mode Badge */}

          <div className="mb-[.25rem] flex w-full">
            {" "}
            <div className="flex w-full">
              {anonymous != "anonymous" ? (
                <img
                  src={state.profile_image}
                  alt="Image"
                  className="mr-2 h-8 w-8 rounded-full"
                />
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  className="mr-2 h-6 w-6 text-gray-400"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
              )}
              {anonymous != "anonymous" ? (
                <a
                  href={`profile?user=${anonymous}`}
                  className=" pt-2  text-sm leading-none text-gray-400" // Use className for Tailwind classes
                  style={{ fontSize: "1em" }} // Correct inline style syntax
                >
                  {anonymous ?? "unknown"}
                </a>
              ) : (
                <span
                  className="pt-1  leading-none text-gray-400"
                  style={{ fontSize: "1em" }}
                >
                  public/Anonymous
                </span>
              )}
            </div>
            <div className="mb-2 flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <div
                  className={`flex items-center space-x-1 rounded-full px-2 py-1 text-xs ${
                    props.mode === "discussion"
                      ? "bg-[#D8BFD8] text-purple-500"
                      : `${modeConfig.color
                          .replace("border-", "bg-")
                          .replace("-500", "-100")} ${modeConfig.color.replace(
                          "border-",
                          "text-"
                        )}`
                  }`}
                >
                  {modeConfig.icon}
                  <span>{modeConfig.label}</span>
                </div>
              </div>
            </div>
            <div className="mb-2 flex items-center justify-between">
              {/* Privacy Status Selector */}
              <div className="privacy-menu-container relative">
                <button
                  onClick={() =>
                    setState((prev) => ({
                      ...prev,
                      showPrivacyMenu: !prev.showPrivacyMenu,
                    }))
                  }
                  className="flex items-center space-x-1 rounded px-2 py-1 transition-colors hover:bg-gray-700"
                  title="Change privacy settings"
                >
                  {state.privacyStatus === "public" && (
                    <>
                      <svg
                        className="h-4 w-4 text-gray-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M10 2a5 5 0 00-5 5v2a2 2 0 00-2 2v5a2 2 0 002 2h10a2 2 0 002-2v-5a2 2 0 00-2-2H7V7a3 3 0 015.905-.75 1 1 0 001.937-.5A5.002 5.002 0 0010 2z" />
                      </svg>
                      <span className="text-nowrap text-xs text-gray-400">
                        Public
                      </span>
                    </>
                  )}
                  {state.privacyStatus === "church_members" && (
                    <>
                      <svg
                        className="h-4 w-4 text-blue-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
                      </svg>
                      <span className="text-nowrap text-xs text-blue-400">
                        Church Members Only
                      </span>
                    </>
                  )}
                  {state.privacyStatus === "elders" && (
                    <>
                      <svg
                        className="h-4 w-4 text-purple-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z"
                          clipRule="evenodd"
                        />
                        <path d="M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z" />
                      </svg>
                      <span className="text-nowrap text-xs text-purple-400">
                        Elders Only
                      </span>
                    </>
                  )}
                  {state.privacyStatus === "me_only" && (
                    <>
                      <svg
                        className="h-4 w-4 text-red-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span className="text-nowrap text-xs text-red-400">
                        Me Only
                      </span>
                    </>
                  )}
                  <svg
                    className="h-3 w-3 text-gray-400"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M19 9l-7 7-7-7"
                    />
                  </svg>
                </button>

                {/* Privacy Menu Dropdown */}
                {state.showPrivacyMenu && (
                  <div className="absolute left-0 z-50 mt-1 w-48 rounded-lg border border-gray-700 bg-gray-800 shadow-xl">
                    <div className="py-1">
                      <button
                        onClick={async () => {
                          const newStatus = "public";
                          const oldStatus = state.privacyStatus;

                          // Optimistically update UI
                          setState((prev) => ({
                            ...prev,
                            privacyStatus: newStatus,
                            showPrivacyMenu: false,
                          }));

                          // Update in Supabase
                          if (props.id) {
                            const result = await updatePostPrivacyStatus(
                              props.id,
                              newStatus
                            );
                            if (result.error) {
                              console.error(
                                "Failed to update privacy status:",
                                result.error
                              );
                              // Revert state on error
                              setState((prev) => ({
                                ...prev,
                                privacyStatus: oldStatus,
                              }));
                            }
                          }
                        }}
                        className={`flex w-full items-center space-x-2 px-4 py-2 text-left text-sm hover:bg-gray-700 ${
                          state.privacyStatus === "public"
                            ? "text-blue-400"
                            : "text-gray-300"
                        }`}
                      >
                        <svg
                          className="h-4 w-4"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path d="M10 2a5 5 0 00-5 5v2a2 2 0 00-2 2v5a2 2 0 002 2h10a2 2 0 002-2v-5a2 2 0 00-2-2H7V7a3 3 0 015.905-.75 1 1 0 001.937-.5A5.002 5.002 0 0010 2z" />
                        </svg>
                        <span>Public</span>
                      </button>
                      <button
                        onClick={async () => {
                          const newStatus = "church_members";
                          const oldStatus = state.privacyStatus;

                          // Optimistically update UI
                          setState((prev) => ({
                            ...prev,
                            privacyStatus: newStatus,
                            showPrivacyMenu: false,
                          }));

                          // Update in Supabase
                          if (props.id) {
                            const result = await updatePostPrivacyStatus(
                              props.id,
                              newStatus
                            );
                            if (result.error) {
                              console.error(
                                "Failed to update privacy status:",
                                result.error
                              );
                              // Revert state on error
                              setState((prev) => ({
                                ...prev,
                                privacyStatus: oldStatus,
                              }));
                            }
                          }
                        }}
                        className={`flex w-full items-center space-x-2 px-4 py-2 text-left text-sm hover:bg-gray-700 ${
                          state.privacyStatus === "church_members"
                            ? "text-blue-400"
                            : "text-gray-300"
                        }`}
                      >
                        <svg
                          className="h-4 w-4"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
                        </svg>
                        <span>Church Members Only</span>
                      </button>
                      <button
                        onClick={async () => {
                          const newStatus = "elders";
                          const oldStatus = state.privacyStatus;

                          // Optimistically update UI
                          setState((prev) => ({
                            ...prev,
                            privacyStatus: newStatus,
                            showPrivacyMenu: false,
                          }));

                          // Update in Supabase
                          if (props.id) {
                            const result = await updatePostPrivacyStatus(
                              props.id,
                              newStatus
                            );
                            if (result.error) {
                              console.error(
                                "Failed to update privacy status:",
                                result.error
                              );
                              // Revert state on error
                              setState((prev) => ({
                                ...prev,
                                privacyStatus: oldStatus,
                              }));
                            }
                          }
                        }}
                        className={`flex w-full items-center space-x-2 px-4 py-2 text-left text-sm hover:bg-gray-700 ${
                          state.privacyStatus === "elders"
                            ? "text-blue-400"
                            : "text-gray-300"
                        }`}
                      >
                        <svg
                          className="h-4 w-4"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M6 6V5a3 3 0 013-3h2a3 3 0 013 3v1h2a2 2 0 012 2v3.57A22.952 22.952 0 0110 13a22.95 22.95 0 01-8-1.43V8a2 2 0 012-2h2zm2-1a1 1 0 011-1h2a1 1 0 011 1v1H8V5zm1 5a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z"
                            clipRule="evenodd"
                          />
                          <path d="M2 13.692V16a2 2 0 002 2h12a2 2 0 002-2v-2.308A24.974 24.974 0 0110 15c-2.796 0-5.487-.46-8-1.308z" />
                        </svg>
                        <span>Elders Only</span>
                      </button>
                      <button
                        onClick={async () => {
                          const newStatus = "me_only";
                          const oldStatus = state.privacyStatus;

                          // Optimistically update UI
                          setState((prev) => ({
                            ...prev,
                            privacyStatus: newStatus,
                            showPrivacyMenu: false,
                          }));

                          // Update in Supabase
                          if (props.id) {
                            const result = await updatePostPrivacyStatus(
                              props.id,
                              newStatus
                            );
                            if (result.error) {
                              console.error(
                                "Failed to update privacy status:",
                                result.error
                              );
                              // Revert state on error
                              setState((prev) => ({
                                ...prev,
                                privacyStatus: oldStatus,
                              }));
                            }
                          }
                        }}
                        className={`flex w-full items-center space-x-2 px-4 py-2 text-left text-sm hover:bg-gray-700 ${
                          state.privacyStatus === "me_only"
                            ? "text-blue-400"
                            : "text-gray-300"
                        }`}
                      >
                        <svg
                          className="h-4 w-4"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                        <span>Me Only</span>
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="mb-8">
            {/* Show title for all modes except prayer */}
            {props.mode !== "prayer" && (
              <div className="mb-2 text-[1.125rem] font-bold leading-6 text-white">
                {title}
              </div>
            )}

            {/* Show text content for all modes except question */}
            {props.mode !== "question" && (
              <p
                className={`text-[.875rem] leading-5 ${
                  props.mode === "prayer" ? "text-white" : "text-gray-400"
                }`}
                style={{ whiteSpace: "pre-line" }}
              >
                {text}
              </p>
            )}

            {/* Show event image if available */}
            {props.mode === "event" && props.imageUrl && (
              <div className="mt-4">
                <img
                  src={props.imageUrl}
                  alt="Event"
                  className="h-48 w-full max-w-md rounded-lg object-cover"
                />
              </div>
            )}
          </div>
          <div className="flex items-center text-gray-400">
            <div className="mr-5 text-sm  text-gray-400"></div>
            <div className="ml-5 contents h-full flex-col justify-between text-right "></div>
            <div className="flex h-[100%] w-full  flex-col text-right">
              <div className="h-inherit"></div>
              <div className="grid justify-items-end">
                {/* Only show View Discussion button for discussion mode */}
                {props.mode === "discussion" && (
                  <button
                    onClick={toggleDiscussion}
                    className="mt-auto flex rounded px-2 py-0.5  text-[11px] text-gray-400 transition-colors hover:text-blue-500"
                  >
                    <svg
                      className="w-[20px] text-orange-100"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 576 512"
                      fill="currentColor"
                    >
                      <path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z" />
                    </svg>
                    <span
                      className="ml-2 text-orange-100"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      {state.isVisible ? "Hide Discussion" : "View Discussion"}
                    </span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  var roots = ReactDOM.createRoot(mains);
  roots.render(
    <Container
      id={id}
      anonymous={anonymous}
      title={title}
      text={text}
      time={time}
      mode={mode}
      imageUrl={imageUrl}
      privacyStatus={privacyStatus}
    />
  );

  //generate the tag
  //18/2/2022, lets off the tag first
  //tag_generator(tag,tag_id);
}
